import List from 'list.js';
var debounce = require('lodash.debounce');

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('#partsguide') == undefined) {
        return;
    }
    const searchInput = document.querySelector('.parts-guide__search-input');
    const clearButton = document.querySelector('.parts-guide__search-clear');

    const _tbody = document.querySelector('#partsguide tbody');
    if (_tbody) {
        _tbody.classList.add('list');
    }

    document.querySelectorAll('#partsguide thead tr th').forEach(function (_element) {
        var category = _element.textContent.toLowerCase().replace(' ', '');
        if (category) {
            category.trim().split(' ').forEach((_class) => {
                _element.classList.add(_class);
            })
        }
    });

    document.querySelectorAll('#partsguide tbody tr').forEach(function (_element) {
        var cells = _element.querySelectorAll('td');

        cells.forEach(function (cell, cellIdx) {
            const _THs = document.querySelectorAll('#partsguide thead tr th');

            if (_THs && _THs.length >= (cellIdx + 1)) {
                cell.classList = _THs[cellIdx].classList;
            }
        });
    });

    clearButton.removeEventListener('click', () => { });
    clearButton.addEventListener('click', function (event) {
        event.stopPropagation();
        searchInput.value = '';
        searchInput.dispatchEvent(new KeyboardEvent('keypress', { 'key': 'del' }));
        clearButton.classList.remove('show');
    });

    var options = {
        valueNames: ['product', 'vendor', 'code']
    };

    var partsList = new List('partsguide', options);

    function updateSearch() {
        var searchString = searchInput.value;
        partsList.search(searchString);
        if (searchInput.value === '' || searchInput.value === '-1') {
            clearButton.classList.remove('show');
        } else {
            clearButton.classList.add('show');
        }
    }

    var debouncedSearch = debounce(updateSearch, 250, { 'maxWait': 2000 });

    const _events = ['change', 'focus', 'blur', 'keyup', 'keypress'];
    _events.forEach(evt => {
        searchInput.removeEventListener(evt, () => { });

        searchInput.addEventListener(evt, function (event) {
            debouncedSearch(event);
        });
    });


    //email modal pop-up
    var vendorAndSupplier = "";
    var modal = document.getElementById('parts-guide__email-modal');
    if (modal) {
        var modalContent = modal.querySelector('.parts-guide__email-modal-content');
    }
    var closeBtn = document.querySelector('.parts-guide__email-modal-close-btn');
    var messageText = document.querySelector('.messageText');

    if (closeBtn) {
        closeBtn.addEventListener('click', function () {
            if (document.querySelector('.red') && messageText) {
                messageText.classList.remove('red');
            }
            modal.querySelector('textarea').value = '';
            showForm();
        });
    }

    if (modalContent) {
        //form stuff
        var modalForm = modalContent.querySelector('form');
        modalForm.addEventListener('submit', function (e) {
            submitMessage(e);
        });
    }

    //add event listener to all <a> with class contactfor
    var partsGuideTable = document.querySelector('.parts-guide');
    for (let i = 1; i < partsGuideTable.rows.length; i++) {
        var helpEmailAddress = partsGuideTable.rows[i].querySelector('.contactfor').innerText;
        partsGuideTable.rows[i].querySelector('.contactfor').innerText = "";
        var anchorTag = document.createElement('a');
        partsGuideTable.rows[i].querySelector('.contactfor').appendChild(anchorTag);

        anchorTag.innerText = helpEmailAddress;

        anchorTag.addEventListener('click', function () {
            modal.style.display = "block";
            //get vendor and supplier info here
            var vendor = partsGuideTable.rows[i].querySelector('.contactfor').parentElement.querySelector('.vendor').innerText.trim();
            var supplier = partsGuideTable.rows[i].querySelector('.contactfor').parentElement.querySelector('.suppliername').innerText.trim();
            vendorAndSupplier = vendor + "/" + supplier;

            if (modalContent) {
                modalContent.querySelector('textarea').innerText = "";
                modalContent.querySelector('.vendor').innerText = "Vendor: " + vendor;
                modalContent.querySelector('.supplier').innerText = "Supplier: " + supplier;
            }
        });
    }

    function submitMessage(e) {
        e.preventDefault();
        if (document.querySelector('.red') && messageText) {
            messageText.classList.remove('red');
        }
        var messageBody = modalForm.querySelector("textarea").value.trim();

        if (messageBody == "") {
            if (messageText) {
                messageText.innerText = 'please enter a message';
                messageText.classList.add('red');
            }
        } else {
            hideForm();

            const request = new XMLHttpRequest();
            request.open("POST", '/umbraco/api/sendmessage/helpmessage', true);
            request.responseType = 'json';
            request.setRequestHeader("Content-Type", "application/json");

            const errorHandler = function () {
                if (messageText) {
                    messageText.innerText = "There was an issue sending your message.";
                }
            }

            request.addEventListener("load", function () {
                if (request.readyState === request.DONE && request.status === 200) {
                    if (messageText) {
                        messageText.innerText = "Your message has been sent.";
                    }
                } else {
                    errorHandler();
                }
            });
            request.addEventListener("error", () => errorHandler());
            request.send(JSON.stringify({
                messageBody: messageBody,
                timeSent: Date().now,
                vendorAndSupplier: vendorAndSupplier
            }));
        }
    }

    //hide form, add response message <p>
    function hideForm() {
        modal.querySelector('textarea').disabled = true;
        modal.querySelector('input').disabled = true;
    }

    //show form, hide response message <p>
    function showForm() {
        modal.style.display = "none";
        if (messageText) {
            messageText.innerText = "";
        }
        modal.querySelector('textarea').disabled = false;
        modal.querySelector('input').disabled = false;
    }
});
